import moment from "moment"
import {UserDateOfBirth} from "@irati/types"

export function dobStringToObject(str: string | null): UserDateOfBirth {
  const dob = str?.split("-") || []
  if (dob.length === 2) {
    return {
      day: parseInt(dob[1], 10),
      month: parseInt(dob[0], 10),
      year: 0
    }
  }

  return {
    day: parseInt(dob[2], 10) || 0,
    month: parseInt(dob[1], 10) || 0,
    year: parseInt(dob[0], 10) || 0
  }
}

export function dobObjectToString(dob: UserDateOfBirth): string | null {
  if (!dob) {
    return ""
  }
  const {year, month, day} = dob
  if (year && month && day) {
    return moment(`${year}-${month}-${day}`, "YYYY-MM-DD").format("YYYY-MM-DD")
  } else if (month && day) {
    return moment(`2020-${month}-${day}`, "YYYY-MM-DD").format("MM-DD")
  } else {
    return null
  }
}
